import { useEffect, useState } from "react";
import BadgesProjects from "../../components/BadgesProjects/BadgesProjects/BadgesProjects";
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import { TrendGraphs } from "../../components/Graphs/TrendGraphs";
import { StateNegotations } from "../../components/Graphs/StateNegotations";
import { FoundInformationTab } from "./FoundInformationTab";
import { AdministratorInfoTab } from "./AdministratorInfoTab";
import { ManagerInfoTab } from "./ManagerInfoTab";
import { FoundEvolutionTab } from "./FoundEvolutionTab";
import { TCTab } from "./T&CTab";
import { SimulateTab } from "./SimulateTab";
import { PageBuySell } from "../PageBuySell/PageBuySell";
import { INVERSIONES_USUARIO } from "../../constants/mockData";
import "./DetailInformation.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { fundInvestment, getFunds } from "../../services/fundService";

const DetailInformation = ({ fundData }) => {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("compra"); // "compra" o "venta"
  const handleOpenCompra = () => {
    setModalType("compra");
    setOpen(true);
  };
  const handleOpenVenta = () => {
    setModalType("venta");
    setOpen(true);
  };
  const [investment, setInvestment] = useState([]);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [inversiones, fondos] = await Promise.all([
          fundInvestment(),
          getFunds(),
        ]);

        const inversionesCompletas = inversiones.map((inv) => {
          const fondo = fondos.find((f) => f.id === inv.fund);
          return {
            ...inv,
            fondoInfo: fondo || {},
          };
        });
        setInvestment(inversionesCompletas);
      } catch (error) {
        console.error("Error cargando inversiones o fondos:", error);
      }
    };

    fetchData();
  }, []);

  const hasInvestmentInThisFund = investment.some(
    (inv) => inv.fondoInfo?.id === fundData.id,
  );

  return (
    <>
      <div className="row mt-4 custom-col-1">
        <div className="col-md-12">
          <div className="container-complete justify-content-center">
            <div className="col-md-6 col-12">
              <img
                src={fundData?.image || fundData?.imagen}
                className="rounded w-100 d-block fund-img"
                alt={fundData?.name}
              />
            </div>
            <div className="col-md-4 col-12">
              <div className="container-title">
                <div className="float-label-right">
                  <BadgesProjects
                    text={
                      fundData?.category ||
                      fundData?.categoria ||
                      "Inmobiliario"
                    }
                  />
                </div>
                <div className="subtitle-project">Vehículo de inversión</div>
                <div className="title-project">
                  {fundData?.name || "Fideicomiso"}
                </div>{" "}
              </div>

              <div className="container-subtitle">
                <div className="container-start">
                  <div className="price-total">
                    $
                    {(
                      (fundData?.price_per_unit ||
                        fundData?.valor_unidad ||
                        100000) *
                      (fundData?.amount_units ||
                        fundData?.unidades_disponibles ||
                        1000)
                    ).toLocaleString("es-CO")}
                  </div>
                  <div className="subtitle-card">Valor del fondo</div>
                </div>
                <div className="container-end">
                  <div className="title2-project">
                    {fundData?.expected_return || fundData?.tir_anual || 10}%
                  </div>
                  <div className="subtitle-card">TIR E.A.</div>
                </div>
              </div>

              <div className="container-subtitle">
                <div className="container-start">
                  <div className="price-total">Trimestral</div>
                  <div className="subtitle-card">Pago del rendimiento</div>
                </div>
                <div className="container-end">
                  <div className="title2-project">5 años</div>
                  <div className="subtitle-card">Tenencia sugerida</div>
                </div>
              </div>

              <hr className="divider-dotted" />

              <div className="container-subtitle">
                <div className="container-start">
                  <div className="title2-project">
                    $
                    {(
                      fundData?.price_per_unit ||
                      fundData?.valor_unidad ||
                      100000
                    ).toLocaleString("es-CO")}
                  </div>
                  <div className="subtitle-card">
                    Valor promedio de la unidad
                  </div>
                </div>
                <div className="container-end">
                  <div className="title2-project">
                    {(
                      fundData?.amount_units ||
                      fundData?.unidades_disponibles ||
                      0
                    ).toLocaleString("es-CO")}
                  </div>
                  <div className="subtitle-card">Unidades disponibles</div>
                </div>
              </div>
              <hr className="divider-dotted" />
              <div className="d-grid gap-2 col-6 mx-auto">
                {hasInvestmentInThisFund ? (
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      className="investment-button"
                      variant="contained"
                      onClick={handleOpenCompra}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                      }}
                    >
                      <i
                        className="bi bi-cart-plus"
                        style={{ fontSize: 22 }}
                      ></i>
                      <span>Reinvertir</span>
                    </Button>
                    <Button
                      className="investment-button"
                      variant="outlined"
                      onClick={handleOpenVenta}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                      }}
                    >
                      <i
                        className="bi bi-cash-coin"
                        style={{ fontSize: 22 }}
                      ></i>
                      <span>Vender</span>
                    </Button>
                  </div>
                ) : (
                  <Button
                    className="investment-button"
                    variant="contained"
                    onClick={handleOpenCompra}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <i className="bi bi-cart-plus" style={{ fontSize: 22 }}></i>
                    <span>Quiero invertir</span>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={"col-sm-12 col-md-12"}>
          <div className="card-container mt-4">
            <div className="column w-100">
              <div className="row w-100 ml-1 mb-3">
                <div className="col-md-12"></div>
                <div
                  className="page-security-head"
                  style={{ padding: "5px 0px 0px" }}
                >
                  <div className="page-security-subtitle">Información</div>
                </div>
                <Tabs
                  defaultActiveKey="estado-negociacion"
                  id="uncontrolled-tab-example"
                >
                  <Tab
                    eventKey="estado-negociacion"
                    title="Estado de negociaciones"
                  >
                    <StateNegotations />
                  </Tab>
                  <Tab
                    eventKey="comportamiento-historico"
                    title="Comportamiento historico"
                  >
                    <TrendGraphs fondo="SiRenta" />
                  </Tab>
                </Tabs>
              </div>
              <div className="row w-100 ml-1"></div>
              <div className="col-md-12"></div>
              <div
                className="page-security-head"
                style={{ padding: "5px 0px 0px" }}
              >
                <div className="page-security-subtitle">
                  Información adicional
                </div>
              </div>
              <Tabs
                defaultActiveKey="informacion-fondo"
                id="uncontrolled-tab-example"
              >
                <Tab
                  style={{
                    border: "1px solid #eeeeee",
                    marginTop: "-5px",
                    borderBottomRightRadius: "10px",
                    borderBottomLeftRadius: "10px",
                    padding: "10px",
                  }}
                  eventKey="informacion-fondo"
                  title="Información del fideicomiso"
                >
                  <FoundInformationTab initialData={fundData} />
                </Tab>
                <Tab eventKey="gestor" title="Gestor">
                  <AdministratorInfoTab fundData={fundData} />
                </Tab>
                <Tab eventKey="administrador" title="Administrador">
                  <ManagerInfoTab fundData={fundData} />
                </Tab>
                <Tab
                  eventKey="estados-financieros"
                  title="Informes de rendimientos"
                >
                  <FoundEvolutionTab fundData={fundData} />
                </Tab>
                <Tab eventKey="t_c" title="T&C">
                  <TCTab />
                </Tab>
                <Tab eventKey="simulador" title="Simulador">
                  <SimulateTab />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <Modal show={open} onHide={handleClose} size="lg">
        <Modal.Header>
          <div className="title-project d-flex align-items-center justify-content-between w-100">
            <span>
              {modalType === "venta"
                ? "Vender"
                : hasInvestmentInThisFund
                  ? "Reinvertir"
                  : "Quiero invertir"}
            </span>
            <button
              type="button"
              className="btn-close ms-auto"
              aria-label="Close"
              onClick={handleClose}
              style={{
                fontSize: 24,
                background: "none",
                border: "none",
                outline: "none",
              }}
            >
              <i className="bi bi-x-circle"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <PageBuySell
            data={{
              fondoInfo: fundData,
              unidades: hasInvestmentInThisFund
                ? INVERSIONES_USUARIO.filter(
                    (inv) => inv.fund === fundData.id,
                  ).reduce((sum, inv) => sum + inv.unidades, 0)
                : 0,
              invested_amount: hasInvestmentInThisFund
                ? INVERSIONES_USUARIO.filter(
                    (inv) => inv.fund === fundData.id,
                  ).reduce((sum, inv) => sum + inv.invested_amount, 0)
                : 0,
            }}
            sell={modalType === "venta"}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DetailInformation;
